import { Unauthorized } from 'layouts/index'
import { useState, useRef, useEffect, useContext } from 'react'
import { LoginContainer } from 'styles/index'
import { Form } from '@unform/web'
import { logo } from 'assets/Icons'
import { DefaultButton, Input, Loading, RecoverPass } from 'components/index'
import { optionsLevels } from 'helper/utils'
import { GeneralContext } from 'context'
import useAuth from 'hooks/useAuth'
import { useNavigate } from 'react-router-dom'
import { useFetch, useStorage } from 'hooks'
import { Background } from 'components/Modal/style'

export default function Login() {
  const [loading, setLoading] = useState(false)
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState<any>()
  const [buttonLoading, setButtonLoading] = useState(false)
  const [colaboradores, setColaboradores] = useStorage('Colaboradores')
  const [especialistas, setEspecialistas] = useStorage('Especialistas')
  const [gestores, setGestores] = useStorage('Gestores')
  const [gestSpec, setGestSpec] = useStorage('GestSpec')
  const auth = useAuth()

  const navigate = useNavigate()
  const from = '/dashboard'
  const formRef = useRef<HTMLFormElement | any>(null)
  const generalCtx = useContext(GeneralContext)

  const stylesheetApi = useFetch('/app')
  const api = useFetch('/gestor/login')

  const [, setPallete] = useStorage('pallete')

  const handleLogin = async (data: any) => {
    if (buttonLoading) return
    // setError(false)
    formRef?.current?.setErrors({})
    try {
      setButtonLoading(true)

      const response = await api.fetch('post', data)
      if (response.fail) {
        console.error(response)
        setButtonLoading(false)
        // setError(response.errors.message)
        return formRef?.current?.setErrors({
          password: response.errors.message,
        })
        // throw new Error(response.errors.message)
      }
      setButtonLoading(false)
      setLoading(true)
      console.log(response.data.token)
      const usr = await auth.signin(response.data.token, () => null)
      if (optionsLevels[usr.level] === 'RH') {
        setLoading(false)
        return navigate('/colaboradores', { replace: true })
      }
      setLoading(false)
      navigate(from, { replace: true })
    } catch (err: any) {
      setButtonLoading(false)
      // setError(err)
      setLoading(false)
      formRef.current.setErrors({ password: err.message })
      console.error('err', err)
    }
  }

  useEffect(() => {
    stylesheetApi.fetch('get').then((response) => {
      setPallete(response.data.pallete)
      generalCtx.dictionary.import(response.data.dictionary)
      generalCtx.gestor.setList(response.data.levelList)
    })
  }, [])

  if (loading) return <Loading />
  return (
    <Unauthorized>
      <LoginContainer>
        <img className="login-company-logo" src={logo} alt="company Logo" />
        <span className="login-title">Acessar plataforma de administração</span>
        <Form
          onSubmit={() => console.log('submit')}
          className="login-form"
          autoComplete="off"
          ref={formRef}
        >
          <div className="input-container">
            <Input
              key="email"
              onChange={(e) => setEmail(e.target.value.trimStart())}
              name="email"
              type="text"
              placeholder="Email"
              value={email}
            />
            <Input
              key="pass"
              onChange={(e) => setPassword(e.target.value)}
              name="password"
              type="password"
              placeholder="Senha"
              value={password}
              // error={error}
            />
          </div>
          <DefaultButton
            style={{ marginTop: 10 }}
            $loading={buttonLoading}
            orange
            onClick={() =>
              handleLogin({
                email: email.trim(),
                password: password.trim(),
              })
            }
          >
            Entrar
          </DefaultButton>
          <RecoverPass to="/recovery-password">Esqueceu a senha?</RecoverPass>
        </Form>
      </LoginContainer>
    </Unauthorized>
  )
}
